// src/pages/confirm/ResetPage.jsx

import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import showPassIcon from "../../medias/showpass.png";
import hidePassIcon from "../../medias/hidepass.png";

const ResetPage = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [token, setToken] = useState('');
    const { t } = useTranslation();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        // Retrieve the token from the URL path
        const urlToken = window.location.pathname.split('/reset/')[1];
        //console.log("Extracted token from URL:", urlToken);
        setToken(urlToken);
    
        // Validate the token by sending a request to the backend
        if (urlToken) {
            // Validate the token by sending a request to the backend
            fetch(`/api/password/validate/${urlToken}`)
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        setEmail(data.email);
                        setStatus('success');
                    } else {
                        setStatus(data.status);
                    }
                })
                .catch(error => {
                    console.error('Error validating token:', error);
                    setStatus('error');
                });
        } else {
            console.error('Token not found in the URL');
            setStatus('error');
        }
    }, []);
  
    const handleSubmit = (e) => {
        e.preventDefault(); // Empêche le comportement par défaut du formulaire

       // console.log("Form submitted with token:", token);
    
        if (password !== confirmPassword) {
            alert("Passwords do not match.");
            return;
        }
    
        // Envoyez la demande pour réinitialiser le mot de passe
        fetch('/api/password/reset', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: token,
                newPassword: password,
            }),
        })
        .then(response => response.json())
        .then(data => {
            if (data.message) {
                window.location.href = data.redirectTo;  
                //console.log("Password reset response:", data);
            } else {
                alert(data.error);
            }
        })
        .catch(error => {
            console.error('Error resetting password:', error);
        });
    };
    
    return (
        <div>
            {status === 'success' && (
                <div className="login-container">
                    <div>
                    <Form className={`reset-card ${status === 'invalid' || status === 'expired' || status === 'error' ? 'message-present' : ''}`} onSubmit={handleSubmit}>
                            <div className="login-tab-container">
                                <div className={`reset-tab`}>
                                    {t('PasswordResetTab')}
                                </div>
                            </div>
                            <div className="form-container">
                                <div className="custom-field">
                                    <Form.Group controlId="formEmail">
                                        <Form.Control
                                            type="text"
                                            value={email}
                                            readOnly
                                            disabled
                                        />
                                    </Form.Group>
                                </div>
                                <div className="custom-field password-field">
                                    <div className="password-input-container">
                                        <Form.Group controlId="formPassword">
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                placeholder="New Password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <img 
                                                src={showPassword ? hidePassIcon : showPassIcon}
                                                alt="Toggle password visibility"
                                                className="toggle-password-icon"
                                                onClick={togglePasswordVisibility}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="custom-field password-field">
                                    <div className="password-input-container">
                                        <Form.Group controlId="formConfirmPassword">
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Confirm Password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <img 
                                                src={showPassword ? hidePassIcon : showPassIcon}
                                                alt="Toggle password visibility"
                                                className="toggle-password-icon"
                                                onClick={togglePasswordVisibility}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                                <Button variant="primary" type="submit" className="custom-button register-button">
                                {t('ResetPasswordBtn')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            )}
            <div className='status-container'>
                {status === 'invalid' && (
                    <div>
                        <p className="custom-status">{t('ResetLinkInvalid')}</p>
                        <p className="custom-status">{t('TryAgainReset')}</p>
                    </div>
                )}
                {status === 'expired' && (
                    <div>
                        <p className="custom-status">{t('ResetLinkExpired')}</p>
                        <p className="custom-status">{t('TryAgainReset')}</p>
                    </div>
                )}
                {status === 'error' && (
                    <div>
                        <p className="custom-status">{t('ResetLinkError')}</p>
                        <p className="custom-status">{t('TryAgainReset')}</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ResetPage;